module.exports = __webpack_public_path__ + "img/united-states-of-america.1f1c3a13.svg";